<template>
  <div class="page_staging">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>工作台</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs" v-if="isOpen">

        <!-- 数据面板 -->
        <div class="shortBox" v-if="hasEmp || hasSalary">
          <div class="r_edit_title">
            <div class="line_box"></div>
            数据
          </div>
          <fieldset v-if="hasEmp">
            <legend>人员</legend>
            <div class="fieldsetBox flex">
              <div class="shortItem">
                <div class="num">{{shortData.Entry}}</div>
                <div class="numTitle">当前在职</div>
              </div>
              <div class="vertical"></div>
              <div class="shortItem">
                <div class="num">{{shortData.InterviewDay}}</div>
                <div class="numTitle">今日待面试</div>
              </div>
              <div class="shortItem">
                <div class="num">{{shortData.EntryDay}}</div>
                <div class="numTitle">今日入职</div>
              </div>
              <div class="shortItem">
                <div class="num">{{shortData.TurnoverDay}}</div>
                <div class="numTitle">今日离职</div>
              </div>
              <div class="vertical"></div>
              <div class="shortItem">
                <div class="num">{{shortData.EntryMonth}}</div>
                <div class="numTitle">本月入职</div>
              </div>
              <div class="shortItem">
                <div class="num">{{shortData.TurnoverMonth}}</div>
                <div class="numTitle">本月离职</div>
              </div>
              <div class="shortItem">
                <div class="num"> {{ shortData.TurnoverMonthRate + '%'}}</div>
                <div class="numTitle">月离职率</div>
              </div>
            </div>
          </fieldset>

          <fieldset>
            <legend v-if="hasSalary">财务</legend>
            <div class="fieldsetBox flex">
              <div class="shortItem">
                <div class="num">{{finData.numberOfPeopleThisMonth}}</div>
                <div class="numTitle">本月发放人数</div>
              </div>
              <div class="vertical"></div>
              <div class="shortItem">
                <div class="num">￥{{finData.amountDisbursedThisMonth}}</div>
                <div class="numTitle">本月发放金额</div>
              </div>
              <div class="vertical"></div>
              <div class="shortItem">
                <div class="num">￥{{finData.settlementAndBillingThisMonth}}</div>
                <div class="numTitle">本月结算开票</div>
              </div>
            </div>
          </fieldset>
        </div>

        <div class="flex" style="margin-top: 20px;">
          <div class="stagingBox" v-loading="loading">
            <div class="flex tabbox">
              <!-- 消息通知 -->
              <div class="r_edit_title">
                <div class="line_box"></div>
                消息
              </div>
              <!-- <el-input v-model="listQuery.name" placeholder="搜索" size="small" style="width: 200px;" clearable></el-input> -->
            </div>
            <div class="approveBox" v-if="msgList.length>0">
              <div class="approveItem flex sb" v-for="(item, index) in msgList" :key="index">
                <div>{{ item.title}}</div>
                <div style="margin-right: 30px;">{{ item.createTime.replace('T',' ') }}</div>
              </div>
              <div class="block">
                <el-pagination v-if="totalCount>0" @current-change="currentChange" :current-page.sync="listQuery.pageModel.page" :page-size="Number(listQuery.pageModel.rows)" layout="total,prev,pager, next" :total="totalCount"></el-pagination>
              </div>
            </div>
            <div v-else>
              <el-empty description="暂无消息通知"></el-empty>
            </div>
          </div>
          <div class="shortcuts">
            <div class="flex tabbox">

              <!-- 消息通知 -->
              <div class="r_edit_title">
                <div class="line_box"></div>
                通知公告
              </div>
              <!-- <el-input v-model="listQuery.name" placeholder="搜索" size="small" style="width: 200px;" clearable></el-input> -->
            </div>
            <el-empty description="暂无消通知公告"></el-empty>
          </div>
        </div>

        <div class="shortBox" style="margin-top: 20px;">
          <div class="flex tabbox">
            <div class="r_edit_title">
              <div class="line_box"></div>
              更多服务
            </div>
          </div>
          <div class="flex">
            <div class="qrItem" v-for="(item,index) in qrList" :key="index">
              <el-image style=" width: 80px;height: 80px;" class="cp" :src="item.url" alt="" @click="showQR(item.url)"></el-image>
              <div class="qrTitle">{{ item.name }}</div>
            </div>
          </div>
        </div>
      </div>
      <div v-else style="background: #fff;">
        <el-empty description="暂未开放"></el-empty>
      </div>
    </div>

    <el-dialog width="400px" title="" :visible.sync="visibleQR" custom-class="helpDialog">
      <div class="qrcodeBox">
        <div class="qrcodeTips">微信扫一扫</div>
        <img :src="qrSrc" alt="" style="width: 300px; height: 300px" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import xz from "../../common";
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    data() {
      return {
        listQuery: {
          pageModel: {
            rows: 10,
            page: 1,
            orderInput: [],
          },
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype,
        },
        roletype: localStorage.loginRoletype,
        shortData: {
          Entry: 0,
          InterviewDay: 0,
          EntryDay: 0,
          TurnoverDay: 0,
          EntryMonth: 0,
          TurnoverMonth: 0,
          TurnoverMonthRate: 0
        },
        qrList: [{
          url: require('../../assets/images/xjbd.jpg'),
          name: '小杰背调'
        }, {
          url: require('../../assets/images/bp.jpg'),
          name: '伴聘'
        }, {
          url: require('../../assets/images/zjy.jpg'),
          name: '职家园'
        }],
        qrSrc: '',
        totalCount: 0,
        loading: false,
        roleName: '',
        isOpen: true,
        workLoading: false,
        msgList: [], //消息列表
        finData: {
          numberOfPeopleThisMonth: 0,
          amountDisbursedThisMonth: 0,
          settlementAndBillingThisMonth: 0,
        },
        visibleQR: false,
        hasEmp: false, //是否有雇员模块权限
        hasEle: false, //是否有电子签模块权限
        hasSalary: false, //是否有发薪模块权限
        hasInv: false,
      }
    },
    created() {
      this.GetMessagePageList(); //消息列表
      this.GetCustomerOnline(); //客户在线-首页-本月发放人数/本月发放金额/本月结算开票
      let a = JSON.parse(localStorage.router)
      const item = a.find(e => e.powername == '客户在线');
      item.children.forEach(element => {
        if (element.powername == '雇员') {
          this.hasEmp = true;
          this.ServiceHomeData(); //首页雇员数据
        } else if (element.powername == '签约') {
          this.hasEle = true;
        } else if (element.powername == '薪酬') {
          this.hasSalary = true;
        } else if (element.powername == '发票') {
          this.hasInv = true;
        }
      });
    },
    methods: {
      checkPermission,
      isNull(o) {
        // console.log('isnull',o)
        return (
          o == undefined ||
          o == "undefined" ||
          (o + "").indexOf("undefined") > -1 ||
          o == null ||
          o == "" ||
          o == "null" ||
          o == [] ||
          o == "NaN" ||
          o == '[{}]'
        );
      },
      ServiceHomeData() {
        this.loading = true;
        xz.ServiceHomeData('', this.roletype).then(res => {
          if (res.status == 'ok') {
            this.shortData = res.data;
          }
        })
      },
      searchHandle() {

      },
      showQR(url) {
        this.qrSrc = url;
        this.visibleQR = true;
      },
      currentChange(val) {
        this.listQuery.pageModel.page = Number(val);
        this.GetMessagePageList();
      },
      GetMessagePageList() {
        this.loading = true;
        xz.ReportFun(this.listQuery, 'GetMessagePageList').then(res => {
          if (res.status == 'ok') {
            this.msgList = res.data.data;
            this.loading = false;
            this.totalCount = res.data.pageModel.totalCount;
          } else {
            this.msgList = [];
            this.loading = false;
            this.totalCount = 0;
          }
        })
      },
      GetCustomerOnline() {
        let d = {
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype,
        }
        xz.ReportFun(d, 'GetCustomerOnline').then(res => {
          if (res.status == 'ok') {
            this.finData = res.data;
          }
        })
      },
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
    padding-top: 10px;
  }

  .stagingBox {
    width: 600px;
    margin-right: 20px;
    border: 1px solid #c1c1c1;
    padding: 10px 20px;
  }

  .shortBox {
    width: 1021px;
    border: 1px solid #c1c1c1;
    padding: 10px 20px;
  }

  .shortcuts {
    // width: 25%;
    width: 360px;
    padding: 10px 20px;
    border: 1px solid #c1c1c1;
  }

  .fieldsetBox {
    padding: 10px 50px;
  }

  .tabbox {
    width: 100%;
    justify-content: space-between;
    margin-bottom: 15px;
  }

  .approveItem {
    margin-bottom: 20px;
  }

  .approveTitle {
    background-color: rgba(229, 115, 51, 1);
    padding: 3px 10px;
    border-radius: 8px;
    margin-right: 15px;
    color: #fff;
  }

  .dataBoard {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
  }

  .dataItem {
    width: 33%;
    text-align: center;
    padding: 20px 0;
  }

  .dataNum {
    font-weight: 600;
    font-size: 24px;
  }

  .dataTitle {
    margin-top: 10px;
    font-size: 14px;
  }

  .messageTitle {
    font-size: 18px;
    font-weight: 600;
    // margin-bottom: 30px;
  }

  .iconBox {
    font-size: 32px;
  }

  .r_edit_title {
    display: flex;
    align-items: center;
    font-size: 16px;
    line-height: 26px;
    font-weight: bold;
    color: #000;
  }

  .line_box {
    width: 3px;
    height: 16px;
    background-color: #19bd92;
    margin-right: 4px;
  }

  .shortItem {
    text-align: center;
    margin-right: 50px;
  }

  .vertical {
    border-left: 2px solid #c1c1c1;
    margin-right: 50px;
  }

  .qrcodeBox {
    text-align: center;
  }

  .qrcodeTips {
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 10px;
  }

  .num {
    font-weight: bolder;
    font-size: 18px;
    color: #000;
  }

  .numTitle {
    font-size: 14px;
    margin-top: 5px;
  }

  fieldset {
    border: 2px solid #c3c3c3;
    margin-top: 20px;
  }

  legend {
    margin-left: 30px;
    padding: 0 10px;
    font-size: 14px;
  }

  .qrItem {
    margin: 0 50px 0 30px;
    text-align: center;
  }

  .qrTitle {
    font-size: 14px;
  }
</style>
<style>
  .page_staging .el-input--small .el-input__icon {
    line-height: 32px;
    height: 32px;
  }

  .page_staging .helpDialog .el-dialog__body {
    padding-top: 10px;
  }
</style>